import React, { useState } from "react";
import { Icon, Popup } from "semantic-ui-react";
import { useSelector } from "react-redux";

export default function ListActionIcon({
  action,
  dataTestId,
  iconStyle,
  alt,
  icon,
  onHoverIcon,
  text,
  semanticIcon,
  noPopup,
}) {
  const { responsive } = useSelector((state) => state.app);

  const [isIconOnHover, setIsIconOnHover] = useState(false);

  return (
    <Popup
      content={<span className="main-colour">{text}</span>}
      position="top center"
      on={"hover"}
      trigger={
        <span
          className="job-list-item-action-icon clickable"
          data-testid={dataTestId}
          onClick={action}
          onMouseEnter={() => setIsIconOnHover(true)}
          onMouseLeave={() => setIsIconOnHover(false)}
        >
          {icon && (
            <img
              style={iconStyle}
              src={isIconOnHover && !responsive.isMobile ? onHoverIcon : icon}
              alt={alt}
            />
          )}
          {semanticIcon && (
            <Icon name={semanticIcon} size="large" color="orange" />
          )}
        </span>
      }
      disabled={responsive.isMobile || noPopup}
    />
  );
}
